import { EditOutlined, EyeFilled, EyeInvisibleFilled } from '@ant-design/icons';
import { Form, Input, Button, Table } from 'antd';
import moment from 'moment';
import { useContext } from 'react';
import { PageContext } from '../../../lib/context';

const Notes = () => {
  const { notesForm, _onFinishNotes, notesTable } = useContext(PageContext);

  const columns = [
    {
      title: 'Notes',
      dataIndex: 'notes',
      key: 'notes',
    },
    {
      title: 'Date added',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: (updated_at: any) => moment(updated_at).format('LLL'),
    },
    {
      title: 'Action',
      key: 'action',
      render: (item: any) => (
        <Button
          type="link"
          onClick={() => notesForm.setFieldsValue({ ...item })}
        >
          <EditOutlined />
        </Button>
      ),
    },
  ];
  return (
    <div>
      <Form form={notesForm} onFinish={_onFinishNotes}>
        <Form.Item
          name="notes"
          rules={[{ required: true, message: 'Notes is required' }]}
        >
          <Input.TextArea rows={10} placeholder="Add notes" />
        </Form.Item>
        <Form.Item hidden name="subscriber_id">
          <Input />
        </Form.Item>
        <Form.Item hidden name="id">
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
      <div className="pt-5">
        <Table columns={columns} dataSource={notesTable} />
      </div>
    </div>
  );
};

export default Notes;
